document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kwo-collgrid]').forEach(function (root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-kwo-filter-pill]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kwo-product-card]'));
    var countEl = root.querySelector('[data-kwo-visible-count]');
    var emptyEl = root.querySelector('[data-kwo-empty-state]');
    var sortSelect = root.querySelector('[data-kwo-sort-select]');

    var knownCategories = pills.map(function (p) { return p.getAttribute('data-filter'); });
    var active = knownCategories.slice();

    function render() {
      var visible = 0;
      cards.forEach(function (card) {
        var cat = card.getAttribute('data-category');
        var isKnown = knownCategories.indexOf(cat) !== -1;
        var show = !isKnown || active.indexOf(cat) !== -1;
        card.hidden = !show;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible;
      if (emptyEl) {
        emptyEl.hidden = visible !== 0;
        emptyEl.style.display = visible !== 0 ? 'none' : '';
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var key = pill.getAttribute('data-filter');
        var idx = active.indexOf(key);
        if (idx === -1) {
          active.push(key);
          pill.classList.add('is-active');
        } else {
          active.splice(idx, 1);
          pill.classList.remove('is-active');
        }
        render();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        window.location.search = params.toString();
      });
    }

    render();
  });
});
